(() => {
  if (window.__ougistRegistrationLinkFixV2) return;
  window.__ougistRegistrationLinkFixV2 = true;

  const targetPath = '/pages/warranty-registration';

  const freshRegistrationHref = (href) => {
    try {
      const url = new URL(href, window.location.origin);
      const path = url.pathname.replace(/\/+$/, '');
      const isRegistrationPath =
        path.endsWith('/pages/product-registration') ||
        path.endsWith('/pages/product-registration.html') ||
        path.endsWith('/pages/warranty-registration') ||
        path.endsWith(targetPath);
      if (!isRegistrationPath) return null;
      url.pathname = targetPath;
      url.search = '';
      return /^https?:\/\//i.test(href) ? url.href : `${url.pathname}${url.hash}`;
    } catch (error) {
      return null;
    }
  };

  const normalizeLinks = () => {
    document.querySelectorAll('a[href*="product-registration"], a[href*="warranty-registration"]').forEach((link) => {
      const href = link.getAttribute('href') || '';
      const nextHref = freshRegistrationHref(href);
      if (nextHref) link.setAttribute('href', nextHref);
    });
  };

  const resourceDownloads = [
    {
      pattern: /ougist-product-manual\.pdf|manual pdf|use guide/i,
      href: 'https://ougist.com/cdn/shop/t/19/assets/ougist-product-use-safety-guide.pdf',
      text: 'Use Guide PDF',
      fileName: 'ougist-product-use-safety-guide.pdf',
    },
    {
      pattern: /ougist-warranty-guide\.pdf|warranty pdf|warranty guide/i,
      href: 'https://ougist.com/cdn/shop/t/19/assets/ougist-warranty-registration-guide.pdf',
      text: 'Warranty Guide PDF',
      fileName: 'ougist-warranty-registration-guide.pdf',
    },
  ];

  const patchRegistrationNavigation = () => {
    const nav = document.querySelector('.ou-reg .ou-nav');
    if (!nav) return;

    const logo = nav.querySelector('.ou-logo');
    const brand = nav.querySelector('a[aria-label*="OUGIST"]') || (logo ? logo.closest('a') : null);
    if (brand) {
      brand.setAttribute('href', 'https://ougist.com/');
      brand.setAttribute('aria-label', 'OUGIST main website');
    }

    const links = nav.querySelector('.ou-nav-links');
    if (!links || links.getAttribute('data-ou-main-nav-synced') === 'true') return;

    links.setAttribute('aria-label', 'Main website and registration links');
    links.setAttribute('data-ou-main-nav-synced', 'true');
    links.innerHTML = [
      '<a href="https://ougist.com/">Home</a>',
      '<a href="https://ougist.com/collections/fire-extinguishers">Fire Extinguishers</a>',
      '<a href="https://ougist.com/pages/contact">Support</a>',
      '<a href="https://ougist.com/pages/about-us">About Company</a>',
      '<a href="#register">Register</a>',
      '<a href="#find-card">Find Card</a>',
    ].join('');
  };

  const patchResourceDownloads = () => {
    const card = document.querySelector('.ou-resource-card');
    if (!card) return;

    const links = Array.from(card.querySelectorAll('.ou-resource-link'));
    resourceDownloads.forEach((download, index) => {
      const link = links.find((candidate) => {
        const haystack = `${candidate.textContent || ''} ${candidate.getAttribute('href') || ''}`;
        return download.pattern.test(haystack);
      }) || links[index];

      if (!link) return;
      link.textContent = download.text;
      link.setAttribute('href', download.href);
      link.setAttribute('download', download.fileName);
      link.setAttribute('target', '_blank');
      link.setAttribute('rel', 'noopener');
      link.setAttribute('aria-label', `Download ${download.text}`);
    });
  };

  const runFixes = () => {
    normalizeLinks();
    patchRegistrationNavigation();
    patchResourceDownloads();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', runFixes, { once: true });
  } else {
    runFixes();
  }

  new MutationObserver(runFixes).observe(document.documentElement, {
    childList: true,
    subtree: true,
  });
})();
